<template>
  <ul class="steps nav nav-justified">
    <li :class="`steps__item ${active === index + 1 ? 'active' : ''}`" v-for="(step, index) in options" :key="index"><span>{{ step }}</span></li>
  </ul>
</template>

<script>
export default {
  name: 'Steps',
  components: {},
  props: {
    options: Array,
    active: Number
  },
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
  @import "../../scss/_variables";

  $brand-primary: $stepsBackground;
  $gray-lighter: #eee;

  .steps {
    margin-bottom: 20px !important;
    padding-left: 0;
    list-style: none;
    margin-top: 0;
    > li {
      border-right: 15px solid transparent;
      border-left: 15px solid transparent;

      &:first-child {
        border-left: 0;
      }
      &:last-child {
        border-right: 0;
      }
    }

    > li > span {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > li > a,
    > li > span {
      background-color: $gray-lighter;
    }

    > li > a:hover {
      background-color: #aaa;
      color: #fff;
    }

    > li:not(:first-child) > a::before,
    > li:not(:first-child) > span::before,
    > li:not(:last-child) > a::after,
    > li:not(:last-child) > span::after {
      position: absolute;
      content: "";
      top: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0 20px 20px;
      z-index: 150;
    }

    > li:not(:first-child) > a::before,
    > li:not(:first-child) > span::before {
      left: -20px;
      border-color: $gray-lighter $gray-lighter $gray-lighter transparent;
    }

    > li:not(:last-child) > a::after,
    > li:not(:last-child) > span::after {
      right: -20px;
      border-color: transparent transparent transparent $gray-lighter;
    }

    > li.active > a,
    > li.active > span {
      background-color: $brand-primary;
      color: #fff;
    }

    > li.active:not(:first-child) > a::before,
    > li.active:not(:first-child) > span::before {
      border-color: $brand-primary $brand-primary $brand-primary transparent;
    }

    > li.active:not(:last-child) > a::after,
    > li.active:not(:last-child) > span::after {
      border-color: transparent transparent transparent $brand-primary;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Steps/steps.vue